export const calculateHeight = (
  height: number,
  windowHeight: number = 768
): { dimension: number; stringValue: string } => {
  return calculateDimension(height, windowHeight, 'height');
};

export const calculateWidth = (
  width: number,
  windowWidth: number = 1366
): { dimension: number; stringValue: string } => {
  return calculateDimension(width, windowWidth, 'width');
};

export const calculateDimension = (
  dimension: number,
  windowDimension: number,
  direction: 'width' | 'height'
): { dimension: number; stringValue: string } => {
  const calculated: number = (dimension / windowDimension) * 100;
  let viewportUnit = '';
  switch (direction) {
    case 'height':
      viewportUnit = 'vh';
      break;
    case 'width':
      viewportUnit = 'vw';
      break;
  }
  const stringValue: string = `${calculated}${viewportUnit}`;

  return { dimension: calculated, stringValue };
};
